import React from 'react';

import { translate } from '../../../i18n/I18nProvider';

function DeleteScheduleConfirmation({ name }) {
  return <div>{`${translate('DELETE_TEXT')} : ${name}?`}</div>;
}

export default DeleteScheduleConfirmation;
